import { IBarcodeSearchFacade, IEntity, SafeAny } from '@pf/shared-common';
import { combineLatest, map, Observable } from 'rxjs';
import { isValue } from '@pf/shared-utility';

export type MultiEntityBarcodeSearchConfig = {
    name: string;
    facade: IBarcodeSearchFacade<IEntity>;
};

export function CreateMultiEntityBarcodeSearchFacade(
    entities: Record<string, MultiEntityBarcodeSearchConfig>
): IBarcodeSearchFacade<IEntity> {
    return {
        searchByBarcode$(barcode: string): Observable<IEntity> {
            return combineLatest(
                Object.keys(entities).map(entityType =>
                    entities[entityType].facade.searchByBarcode$(barcode).pipe(
                        map(result => {
                            if (!result) {
                                return null;
                            }
                            (result as SafeAny).entityType = entityType;
                            return result;
                        })
                    )
                )
            ).pipe(
                map(results => {
                    return results.find(isValue) as IEntity;
                })
            );
        },
    };
}
